module.exports = {
    title: 'Road to a Million',
    lotteryName: 'Illinois Lottery',
    promotion_id: '7366',
    promotion: 'roadtoamillion',
    appUrl: '/roadtoamillion',
    prodhost: 'newhampshire.lotterybonuszone.com',
    lotteryUrl: 'https://www.illinoislottery.com/',
    uathost: 'nh.uat.lotterybonuszone.com',
    loginLink: '/roadtoamillion/login',
    registerLink: '/general/users/register?promotion=roadtoamillion',
    forgot: '/general/users/forgot',
    apiClientConfig: {
        appUrl: '/roadtoamillion',
        routes: {
            login: 'scbzApi.login',
            logout: 'scbzApi.logout',
            enterDrawTicket: 'scbzApi.enterDrawTicket',
            getEntries: 'scbzApi.getEntries',
            getPlayerData: 'scbzApi.getPlayerData',
            setEntryFlashGameFlag: 'scbzApi.setEntryFlashGameFlag',
            update: 'fauxScbzApi.update',
            register: 'fauxScbzApi.register',
            winners: 'fauxScbzApi.winners',
            postFeedback: 'fauxScbzApi.postFeedback',
            forgotPassword: 'fauxScbzApi.forgotPassword',
            getGame: 'fauxScbzApi.getGame',
            getGameOver: 'fauxScbzApi.getGameOver',
        },
    },
};
